import { environment } from '../../environments/environment';

export const apiConfig = environment.api;
